import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';

export const useGetSelectedLabelProviderIds = (sellerLabelProviderIds) => {
  const labelProviders = useSelector((state) => Global.selectSellerLabelProviders(state));
  const selectedLabelProviderIds = labelProviders.reduce((acc, p) => {
    if (sellerLabelProviderIds.includes(p.sellerLabelProviderId)) {
      acc.push(p.labelProviderId);
      return acc;
    }
    return acc;
  }, []);
  return selectedLabelProviderIds;
};
